import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./contentText.html";
import { getBooleanAttr } from '../common/common';
class ContentText extends LightningElement {
  constructor(...args) {
    super(...args);
    this.text = void 0;
    this.typeStyle = void 0;
    this._isLoading = false;
  }
  set isLoading(value) {
    this._isLoading = getBooleanAttr(value);
  }
  get isLoading() {
    return this._isLoading;
  }
  set loadingWidth(value) {
    this.template.host.style.setProperty('--ads-loading-width', value);
  }
  get loadingWidth() {
    return this.template.host.style.getPropertyValue('--ads-loading-width');
  }
  set maxLines(value) {
    if (Number.isNaN(value)) {
      throw new Error('max lines must be a number');
    }
    this.template.host.style.setProperty('--ads-max-lines', value);
  }
  get maxLines() {
    return this.template.host.style.getPropertyValue('--ads-max-lines');
  }
  get styleClass() {
    if (!this.typeStyle) {
      return 'text';
    }
    return 'color-text';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ContentText, {
  publicProps: {
    text: {
      config: 0
    },
    typeStyle: {
      config: 0
    },
    isLoading: {
      config: 3
    },
    loadingWidth: {
      config: 3
    },
    maxLines: {
      config: 3
    }
  },
  track: {
    _isLoading: 1
  }
});
const __lwc_component_class_internal = _registerComponent(ContentText, {
  tmpl: _tmpl,
  sel: "ads-content-text",
  apiVersion: 62
});
export default __lwc_component_class_internal;